import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Group } from "./group.model";

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  selectedGroup: Group;
  GroupList: Group[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDGroup(group: Group) {
    group.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    group.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    group.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    group.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = group;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Group/IUD', body, { headers: headers });
  }

  // GetCenterList() {
  //   this.selectedGroup = new Group();
  //   this.selectedGroup.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //   this.selectedGroup.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //   this.selectedGroup.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //   this.selectedGroup.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  //   let body = this.selectedGroup;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/Center/FetchList', body, { headers: headers });
  // }

  FetchGroupByGroupId(group) {

    group.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    group.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    group.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    group.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = group;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Group/Fetch', body, { headers: headers });
  }

  //-----------------------------FetchGroupList----Component-------------------------------------
  FetchGroupList() {

    this.selectedGroup = new Group();
    this.selectedGroup.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedGroup.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedGroup.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedGroup.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedGroup;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Group/FetchList', body, { headers: headers });
  }

}

